// eslint-disable-next-line no-shadow
enum TaskType {
    BASIC_TASK = 'BasicTask',
    CALC_TASK = 'CalcTask',
}

export default TaskType;
